import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { useState } from "react";
import {
  DropMenuBranchSelection,
  DropMenuShiftSelection,
} from "../Managers/dropDownMenu";
import {
  BranchModel,
  EnumAlertDialogType,
  EnumUserAcces,
  ShiftModel,
  ShiftPlanEmployee,
  ShiftPlanModel,
  UserModel,
} from "../Managers/dataStructures";
import SPEmployeePanel from "./SPEmployeePanel";

import SPShiftPlanPanel from "./SPShiftPlanPanel";
import {
  createShiftPlan,
  createShiftPlanEmpoyee,
  currentDateFormat,
  getLanguage,
  getUserRoleObject,
  noneBranchObject,
  noneShiftObject,
} from "../Managers/dataProvider";
import {
  fetchBranchUsersForShiftPlaner,
  fetchPrefDayFromListOfUsers,
  fetchShiftPlan,
  fetchShiftPlanEmployees,
  postShiftPlan,
  postShiftPlanEntries,
  timeout,
} from "../Managers/wepApiManager";
import {
  PositiveToast,
  NegativeToast,
  ActivityIndicator,
} from "../Managers/utilityComponents";
import {
  processAutofillSchedule,
  processDownloadReport,
} from "../Managers/processManager";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import React from "react";
import {
  dateToString,
  dateToStringForPicker,
} from "../Managers/utilityFunctions";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PDFShiftPlan from "./PDFShiftPlan";

interface SPWorkstationProps {
  array_shifts: ShiftModel[];
  array_branches: BranchModel[];
}

export default function SPWorkstation(props: SPWorkstationProps) {
  const isEnglish = getLanguage();
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const [isPlanInProgress, setIsPlanInProgress] = useState<boolean | undefined>(
    undefined
  );
  const [isActivityIndicatorForPlan, setIsActivityIndicatorForPlan] =
    useState<boolean>(false);
  const [isSubmitInProgress, setIsSubmitInProgress] = useState<boolean>(false);
  const [selectedDate, setSelectDate] = useState<Date>(new Date());
  const [selectedShift, setSelectedShift] = useState<ShiftModel>(
    noneShiftObject()
  );
  const [selectedBranch, setSelectedBranch] = useState<BranchModel>(
    noneBranchObject()
  );
  const [objectShiftPlan, setObjectShiftPlan] = useState<ShiftPlanModel | null>(
    null
  );
  const [isCancelPlanInProgress, setIsCancelPlanInProgress] =
    useState<boolean>(false);
  const [isToastVisible, setIsToastVisible] = useState<EnumAlertDialogType>(
    EnumAlertDialogType.NEUTRAL
  );
  const [isSPEmpPanelActivity, setIsSPEmpPanelActivity] =
    useState<boolean>(false);
  const [toastAlert, setToastAlert] = useState<string>("");
  const [empPanelUserBranch, setEmpPanelUserBranch] = useState<BranchModel>(
    noneBranchObject()
  );
  const [empPanelUserArray, setEmpPanelUserArray] = useState<UserModel[]>([]);
  const [isGeneratingPDF, setIsGeneratingPDF] = React.useState<boolean>(false);

  const isSelectionBarEnabled: boolean =
    isPlanInProgress === true ? true : false;
  const currentDate: string = dateToString(selectedDate);
  const currentDateForPicker: string = dateToStringForPicker(selectedDate);

  function onStart() {
    // setIsPlanInProgress(true);
    // setIsDisabled(false);
    setIsSubmitInProgress(false);

    if (isActivityIndicatorForPlan === true) {
      return;
    }
    setIsPlanInProgress(undefined);
    if (selectedBranch === null || selectedBranch.branch_id === "-1") {
      showAlert(false, isEnglish ? "Select Branch" : "Filiale auswählen");
      return;
    }
    if (selectedShift === null || selectedShift.shift_id === "-1") {
      showAlert(false, isEnglish ? "Select Shift" : "Schicht auswählen");
      return;
    }

    updateShiftPlan(selectedDate, selectedBranch, selectedShift);
  }

  async function updateShiftPlan(
    date: Date,
    branch: BranchModel | null,
    shift: ShiftModel | null
  ) {
    if (date !== null && branch !== null && shift !== null) {
      setIsActivityIndicatorForPlan(true);
      fetchShiftPlan(
        date,
        branch.branch_id,
        shift.shift_id,
        (shift_plan_: ShiftPlanModel | undefined) => {
          if (shift_plan_ !== undefined) {
            const tempShiftPlan: ShiftPlanModel = shift_plan_;
            const bIndex: number = props.array_branches.findIndex(
              (x) => x.branch_id === tempShiftPlan.branch_id
            );
            if (bIndex !== -1) {
              tempShiftPlan.branch = props.array_branches[bIndex];
            }
            const sIndex: number = props.array_shifts.findIndex(
              (x) => x.shift_id === tempShiftPlan.shift_id
            );
            if (sIndex !== -1) {
              tempShiftPlan.shift = props.array_shifts[sIndex];
            }
            if (tempShiftPlan !== null) {
              fetchShiftPlanEmployees(
                tempShiftPlan,
                (shift_plan_with_data: ShiftPlanModel) => {
                  setObjectShiftPlan(shift_plan_with_data);
                  setIsDisabled(true);
                  setIsPlanInProgress(false);
                  setIsActivityIndicatorForPlan(false);
                }
              );
            }
            //setObjectShiftPlan(tempShiftPlan);
            setIsDisabled(true);
            setIsPlanInProgress(false);
            showAlert(
              true,
              isEnglish
                ? "Shift Plan for date Found fetching data.."
                : "Schichtplan für das Datum gefunden, Daten werden abgerufen..."
            );
          } else {
            showAlert(
              true,
              isEnglish
                ? "No shift plan exists. Creating Shift plan"
                : "Kein Schichtplan vorhanden. Schichtplan wird erstellt."
            );
            const newShiftPlan: ShiftPlanModel = createShiftPlan(
              date,
              branch,
              shift
            );
            setObjectShiftPlan(newShiftPlan);
            setIsSPEmpPanelActivity(true);
            setIsDisabled(false);
            //setIsPlanInProgress(true);
            fetchBranchUsersForShiftPlaner(
              date,
              branch.branch_id,
              shift.shift_id,
              (array_users: UserModel[]) => {
                setIsSPEmpPanelActivity(false);
                setEmpPanelUserArray(array_users);
                showAlert(
                  true,
                  isEnglish
                    ? "Fetching User data to auto-populate"
                    : "Benutzerdaten werden abgerufen, um automatisch auszufüllen."
                );
                fetchPrefDayFromListOfUsers(
                  array_users,
                  (isSuccess: boolean, array_users_filled) => {
                    setIsActivityIndicatorForPlan(false);
                    setIsPlanInProgress(true);
                    setIsDisabled(false);
                    if (isSuccess) {
                      setEmpPanelUserArray(array_users_filled);
                      autofill(
                        array_users_filled,
                        newShiftPlan,
                        array_users_filled
                      );
                    }
                  }
                );
              }
            );
          }
        }
      );
    }
  }

  function autofill(
    array_users: UserModel[],
    newShiftPlan: ShiftPlanModel,
    array_users_filled: UserModel[]
  ) {
    const array_requiredUsers = processAutofillSchedule(
      selectedShift,
      selectedDate,
      array_users
    );

    let array_branchEmployess = array_users_filled;
    let array_employees: ShiftPlanEmployee[] = [];
    for (let i = 0; i < array_requiredUsers.length; i++) {
      array_employees.push(
        createShiftPlanEmpoyee(array_requiredUsers[i], selectedShift)
      );
      const eIndex: number = empPanelUserArray.findIndex(
        (x) => x.user_id === array_requiredUsers[i].user_id
      );
      if (eIndex !== -1) {
        array_branchEmployess.splice(eIndex, 1);
      }
    }

    if (newShiftPlan !== null) {
      let tempArr: ShiftPlanEmployee[] = newShiftPlan.array_employees;
      tempArr.push(...array_employees);

      const objectSP: ShiftPlanModel = {
        branch: newShiftPlan?.branch,
        date: newShiftPlan?.date,
        shift: newShiftPlan?.shift,
        array_employees: tempArr,
      };
      newShiftPlan.array_employees = tempArr;
      setEmpPanelUserArray(array_branchEmployess);
      setObjectShiftPlan(objectSP);
      showAlert(
        true,
        isEnglish
          ? "Auto-filling schedule complete."
          : "Automatische Schichtplanung abgeschlossen."
      );
    }
  }

  function onSubmit() {
    if (isSubmitInProgress === true) {
      return;
    }
    if (objectShiftPlan?.array_employees.length === 0) {
      showAlert(
        false,
        isEnglish
          ? "Can't submit an empty plan"
          : "Kann keinen leeren Plan einreichen."
      );
      return;
    }
    if (
      objectShiftPlan?.team_lead_id === undefined ||
      objectShiftPlan.team_lead_id == "-1"
    ) {
      if (
        objectShiftPlan?.array_employees.find(
          (x) =>
            x.user.role.type === EnumUserAcces.TEAM_LEAD ||
            x.user.tempRole?.type === EnumUserAcces.TEMP_TEAM_LEAD
        ) === undefined
      ) {
        showAlert(
          false,
          isEnglish
            ? "Team Lead missing. Please assign a team lead"
            : "Sie haben keinen Teamleiter ausgewählt. Bitte fügen Sie einen Teamleiter hinzu oder benennen einen Mitarbeiter zum Teamleiter"
        );
        return;
      }
    } else {
    }

    setIsSubmitInProgress(true);
    if (objectShiftPlan !== null) {
      postShiftPlan(objectShiftPlan, (isSuccess: boolean, plan_id: string) => {
        if (isSuccess) {
          let tempSP = objectShiftPlan;
          if (objectShiftPlan.plan_id !== undefined) {
            tempSP.plan_id = objectShiftPlan.plan_id;
          } else {
            tempSP.plan_id = plan_id;
          }
          setObjectShiftPlan(tempSP);
          postShiftPlanEntries(tempSP, (isSuccess: boolean) => {
            setIsSubmitInProgress(false);
            if (isSuccess) {
              setIsDisabled(true);
              setIsPlanInProgress(false);
              showAlert(
                true,
                isEnglish
                  ? "Shift Plan submitted."
                  : "Die Personaleinsatzplanung ist abgeschlossen."
              );
            }
          });
        }
      });
    }
  }

  function onDiscardPlan() {
    setIsCancelPlanInProgress(true);
  }

  function onDiscardYes() {
    setIsCancelPlanInProgress(false);
    setObjectShiftPlan(null);
    setIsPlanInProgress(undefined);
    setIsDisabled(true);
    setEmpPanelUserArray([]);
    showAlert(
      false,
      isEnglish ? "Shift Plan discarded" : "Schichtplan verworfen."
    );
  }

  function onDiscardNo() {
    setIsCancelPlanInProgress(false);
  }

  function onEditPlan() {
    setIsPlanInProgress(true);
    setIsDisabled(false);
  }

  function onDateChange(x: dayjs.Dayjs | null) {
    //console.log("selected Date=" + x?.format("DD-MMM-YYYY"));
    setSelectDate(x?.toDate() as Date);
  }

  function onMakeTeamLead(item: ShiftPlanEmployee) {
    let array_shiftPlanEmployee: ShiftPlanEmployee[] =
      objectShiftPlan !== null ? objectShiftPlan?.array_employees : [];
    const uIndex: number = array_shiftPlanEmployee.findIndex(
      (x) => x.user.user_id === item.user.user_id
    );
    if (uIndex !== -1) {
      if (array_shiftPlanEmployee[uIndex].user.tempRole === undefined) {
        array_shiftPlanEmployee[uIndex].user.tempRole = getUserRoleObject(
          EnumUserAcces.TEMP_TEAM_LEAD
        );
      } else {
        array_shiftPlanEmployee[uIndex].user.tempRole = undefined;
      }
      if (objectShiftPlan !== null) {
        // const objectSP: ShiftPlanModel = {
        //   branch: objectShiftPlan?.branch,
        //   date: objectShiftPlan?.date,
        //   shift: objectShiftPlan?.shift,
        //   array_employees: array_shiftPlanEmployee,
        // };
        const objectSP: ShiftPlanModel = {
          plan_id: objectShiftPlan.plan_id,
          shift_id: objectShiftPlan.shift_id,
          team_lead_id: objectShiftPlan.team_lead_id,
          branch_id: objectShiftPlan.branch_id,
          date: objectShiftPlan?.date,
          branch: objectShiftPlan?.branch,
          shift: objectShiftPlan?.shift,
          array_employees: array_shiftPlanEmployee,
        };
        objectShiftPlan.array_employees = array_shiftPlanEmployee;
        setObjectShiftPlan(objectSP);
      }
    }
  }

  async function onBranchSelect(item: BranchModel | ShiftModel) {
    const branch_: BranchModel = item as BranchModel;
    setSelectedBranch(branch_);
    if (isPlanInProgress === false || isPlanInProgress === undefined) {
      setEmpPanelUserBranch(branch_);
    }
  }

  function onShiftSelect(item: BranchModel | ShiftModel) {
    setSelectedShift(item as ShiftModel);
  }

  function onRemove(item: ShiftPlanEmployee) {
    let array_shiftPlanEmployee: ShiftPlanEmployee[] =
      objectShiftPlan !== null ? objectShiftPlan?.array_employees : [];
    const uIndex: number = array_shiftPlanEmployee.findIndex(
      (x) => x.user.user_id === item.user.user_id
    );
    if (uIndex !== -1) {
      array_shiftPlanEmployee.splice(uIndex, 1);
    }
    if (empPanelUserBranch.branch_id === item.user.permanent_branch_id) {
      //check for duplicate
      const dupliIndex: number = empPanelUserArray.findIndex(
        (x) => x.user_id === item.user.user_id
      );
      if (dupliIndex === -1) {
        empPanelUserArray.push(item.user);
        setEmpPanelUserArray(empPanelUserArray);
      }
    }
    if (objectShiftPlan !== null) {
      // const objectSP: ShiftPlanModel = {
      //   branch: objectShiftPlan?.branch,
      //   date: objectShiftPlan?.date,
      //   shift: objectShiftPlan?.shift,
      //   array_employees: array_shiftPlanEmployee,
      // };

      // remove item is a team lead then remove the id from the shift plan
      let team_lead_id = objectShiftPlan.team_lead_id;
      if (item.user.user_id === objectShiftPlan.team_lead_id) {
        team_lead_id = "-1";
      }
      //
      const objectSP: ShiftPlanModel = {
        plan_id: objectShiftPlan.plan_id,
        shift_id: objectShiftPlan.shift_id,
        team_lead_id: team_lead_id,
        branch_id: objectShiftPlan.branch_id,
        date: objectShiftPlan?.date,
        branch: objectShiftPlan?.branch,
        shift: objectShiftPlan?.shift,
        array_employees: array_shiftPlanEmployee,
      };
      objectShiftPlan.array_employees = array_shiftPlanEmployee;
      setObjectShiftPlan(objectSP);
    }
  }

  // SPEmployee Functions
  function onEmpPanelChangeBranch(branch: BranchModel) {
    //console.log("emp panel branch=" + branch.name);
    setEmpPanelUserBranch(branch);
    updateSPEmpPanel(branch);
  }
  async function updateSPEmpPanel(branch: BranchModel) {
    if (empPanelUserBranch.branch_id !== "-1") {
      setIsSPEmpPanelActivity(true);
      fetchBranchUsersForShiftPlaner(
        selectedDate,
        branch.branch_id,
        selectedShift.shift_id,
        (array_users: UserModel[]) => {
          setEmpPanelUserArray(array_users);
          setIsSPEmpPanelActivity(false);
        }
      );
      // fetchUsersForBranch(branch.branch_id, (array_users: UserModel[]) => {
      //   setEmpPanelUserArray(array_users);
      //   setIsSPEmpPanelActivity(false);
      // });
    }
  }

  function filterUPUsers(array_users: UserModel[]) {
    let filteredArray: UserModel[] = [];
    if (objectShiftPlan !== undefined && objectShiftPlan !== null) {
      for (let i = 0; i < array_users.length; i++) {
        const uIndex: number | undefined =
          objectShiftPlan?.array_employees.findIndex(
            (x) => x.user.email_id === array_users[i].email_id
          );
        if (uIndex === -1) {
          filteredArray.push(array_users[i]);
        }
      }
    } else {
      return array_users;
    }

    return filteredArray;
  }

  function onEmpPanelAddUser(user: UserModel) {
    if (objectShiftPlan === undefined || objectShiftPlan === null) {
      return;
    }
    let isUserAdded: boolean = false;
    let array_shiftPlanEmployee: ShiftPlanEmployee[] =
      objectShiftPlan !== null ? objectShiftPlan?.array_employees : [];
    //check for duplicate employ
    const dupliIndex: number = array_shiftPlanEmployee.findIndex(
      (x) => x.user.user_id === user.user_id
    );
    if (dupliIndex === -1) {
      if (user.role.type === EnumUserAcces.TEAM_LEAD) {
        //check for duplicat team lead
        const previousTLIndex: number = array_shiftPlanEmployee.findIndex(
          (x) => x.user.role.type === EnumUserAcces.TEAM_LEAD
        );
        if (previousTLIndex === -1) {
          array_shiftPlanEmployee.push(
            createShiftPlanEmpoyee(user, selectedShift)
          );
          isUserAdded = true;
          //if added user is team lead remove all temporary team leads
          for (let i = 0; i < array_shiftPlanEmployee.length; i++) {
            array_shiftPlanEmployee[i].user.tempRole = undefined;
          }
        } else {
          showAlert(
            false,
            isEnglish
              ? "Error: Can't add another team lead beacuse team lead is already present"
              : "Fehler: Kein weiterer Teamleiter kann hinzugefügt werden, da bereits ein Teamleiter vorhanden ist."
          );
        }
      } else {
        let newUser = createShiftPlanEmpoyee(user, selectedShift);
        array_shiftPlanEmployee.push(newUser);
        isUserAdded = true;
      }
    } else {
      showAlert(
        false,
        isEnglish
          ? "Error: Can't add the same user again."
          : "Fehler: Der gleiche Benutzer kann nicht erneut hinzugefügt werden."
      );
    }

    if (isUserAdded) {
      let usersListTemp: UserModel[] = empPanelUserArray;
      const uIndex: number = usersListTemp.findIndex(
        (x) => x.user_id === user.user_id
      );
      if (uIndex !== -1) {
        usersListTemp.splice(uIndex, 1);
      }
      if (objectShiftPlan !== null) {
        const objectSP: ShiftPlanModel = {
          plan_id: objectShiftPlan.plan_id,
          shift_id: objectShiftPlan.shift_id,
          team_lead_id: objectShiftPlan.team_lead_id,
          branch_id: objectShiftPlan.branch_id,
          date: objectShiftPlan?.date,
          branch: objectShiftPlan?.branch,
          shift: objectShiftPlan?.shift,
          array_employees: array_shiftPlanEmployee,
        };
        objectShiftPlan.array_employees = array_shiftPlanEmployee;
        setEmpPanelUserArray(usersListTemp);
        setObjectShiftPlan(objectSP);
      }
    }
  }

  async function addDelay(callback: () => void) {
    await processDownloadReport();
    callback();
  }

  function onCreatePDF() {
    if (isActivityIndicatorForPlan) {
      return;
    }
    setIsGeneratingPDF(true);
    addDelay(() => {
      generatePDF();
      setIsGeneratingPDF(false);
    });
  }

  function generatePDF() {
    const planName: string =
      "Schedule-" + selectedBranch.name + "-" + currentDate + ".pdf";
    const input = document.getElementById("divToPrint");
    let formatHeight: number = 4;
    if (objectShiftPlan !== null) {
      formatHeight = objectShiftPlan?.array_employees.length * 100;
    }

    if (input !== null) {
      html2canvas(input).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF({
          orientation: formatHeight < 500 ? "landscape" : "portrait",
          unit: "px",
          format: "a4",
        });
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save(planName);
        // const pdf = new jsPDF({
        //   orientation: formatHeight < 450 ? "landscape" : "portrait",
        //   unit: "px",
        //   format: [500, formatHeight / 1.5],
        //   //format: "a4",
        // });
        // //pdf.addImage(imgData, "JPEG", 0, 0, 200, 100);
        // pdf.addImage(
        //   imgData,
        //   "PNG",
        //   0,
        //   0,
        //   500,
        //   formatHeight / 2,
        //   planName
        //   //"SLOW"
        // );
        // // pdf.output('dataurlnewwindow');
        // pdf.save(planName);
      });
    }
  }

  async function showAlert(isPositive: boolean, alertText: string) {
    setToastAlert(alertText);
    if (isPositive) {
      setIsToastVisible(EnumAlertDialogType.POSITIVE);
    } else {
      setIsToastVisible(EnumAlertDialogType.NEGATIVE);
    }
    await timeout(3000);
    setIsToastVisible(EnumAlertDialogType.NEUTRAL);
  }

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            {isEnglish
              ? "Shift Planer Work Station"
              : "Personalarbeitszeitplanung"}
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            {isToastVisible === EnumAlertDialogType.NEUTRAL
              ? isEnglish
                ? "Shift Planer can plan shifts. Select date, shift and branch for which the shift is going to be planned. An auto-generated shift will be available to modify. Add or remove employee from employee list."
                : "Die Arbeitsschichten können hier erstellt werden. Wählen Sie zuerst den Tag aus, dann die Filiale und die Schicht. Die Mitarbeiter, die für den Tag freigegeben sind, werden automatisch hinzugefügt. Weitere Mitarbeiter können durch Auswahl anderer Filialen hinzugefügt werden."
              : isToastVisible === EnumAlertDialogType.POSITIVE
              ? PositiveToast(toastAlert)
              : NegativeToast(toastAlert)}
          </p>
        </div>
      </div>

      <div className="sm:flex ">
        <div className="sm:flex-auto sm:w-3/4 overflow-scroll">
          <div className="mt-4 sm:flex mr-2">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker"]}>
                <DatePicker
                  label={isEnglish ? "Shift Plan Date" : "Datum"}
                  format={currentDateFormat()}
                  onAccept={(x) => onDateChange(x)}
                  defaultValue={dayjs(currentDateForPicker)}
                  disabled={isSelectionBarEnabled}
                  //sx={{ height: "5px", alignContent: "center", width: "20px" }}
                />
              </DemoContainer>
            </LocalizationProvider>
            <div className="sm:flex-auto sm:flex mr-2">
              <div className="sm:mx-4 mr-2 lg:w-1/3">
                <DropMenuBranchSelection
                  onSelectItem={onBranchSelect}
                  selectedItem={selectedBranch}
                  isDisabled={isSelectionBarEnabled}
                  array_branches={props.array_branches}
                />
              </div>
              <div className="mr-2 sm:mt-0 mt-4 lg:w-1/3">
                <DropMenuShiftSelection
                  onSelectItem={onShiftSelect}
                  selectedItem={selectedShift}
                  isDisabled={isSelectionBarEnabled}
                  array_shifts={props.array_shifts}
                />
              </div>
            </div>
          </div>

          {isPlanInProgress === undefined ? (
            <div className="mt-5 flex">
              <button
                onClick={onStart}
                type="button"
                className="block mx-auto items-center justify-center min-w-[200px] rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                {isEnglish ? "Start" : "Start"}
              </button>
            </div>
          ) : isPlanInProgress === true ? (
            <div className="mt-5 flex ">
              <div className="flex items-center justify-center mx-auto">
                <button
                  onClick={onDiscardPlan}
                  type="button"
                  className="text-sm font-semibold leading-6 text-gray-900"
                >
                  {isEnglish ? "Cancel" : "Abbrechen"}
                </button>
                <button
                  onClick={onSubmit}
                  type="button"
                  className={
                    "ml-10 min-w-[200px] rounded-md bg-red-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600" +
                    (isSubmitInProgress === true
                      ? " inline-flex items-center"
                      : "block")
                  }
                >
                  {isSubmitInProgress ? ActivityIndicator(0) : null}
                  {isEnglish ? "Submit" : "Bestätigen"}
                </button>
              </div>
            </div>
          ) : (
            <div className="mt-5 flex justify-center">
              <button
                onClick={onStart}
                type="button"
                className="block mx-5 items-center justify-center min-w-[200px] rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                {isEnglish ? "Start" : "Start"}
              </button>
              <PDFDownloadLink
                document={
                  <PDFShiftPlan
                    array_employees={
                      objectShiftPlan !== null
                        ? objectShiftPlan.array_employees
                        : []
                    }
                    current_date={currentDate}
                    branch={selectedBranch.name}
                    shift={selectedShift.title}
                    tl_id={objectShiftPlan?.team_lead_id}
                  />
                }
                fileName={
                  "Schedule-" + selectedBranch.name + "-" + currentDate + ".pdf"
                }
              >
                <button
                  //onClick={onCreatePDF}
                  type="button"
                  className={
                    isGeneratingPDF === true
                      ? "block mx-5 min-w-[200px] rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                      : "block mx-5 items-center justify-center min-w-[200px] rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  }
                >
                  {isGeneratingPDF === true ? ActivityIndicator(0) : null}
                  {isEnglish
                    ? "Download PDF"
                    : "Personaleinsatzplan als PDF Datei herunterladen"}
                </button>
              </PDFDownloadLink>
              <button
                onClick={onEditPlan}
                type="button"
                className="block  mx-5 items-center justify-center min-w-[200px] rounded-md bg-red-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
              >
                {isEnglish ? "Edit Plan" : "Personaleinsatzplan bearbeiten"}
              </button>
            </div>
          )}
          {isPlanInProgress === false ? (
            <div className="flex justify-center mt-5">
              <p className="text-sm text-gray-700">
                {isEnglish
                  ? "Displaying Shift Plan For Current Selection"
                  : "Unten sehen Sie den freigegebenen Personaleinsatzplan für das ausgewählte Datum und die gewählte Filiale."}
              </p>
            </div>
          ) : isPlanInProgress === true ? (
            <div className="flex justify-center mt-5">
              <p className="text-sm text-gray-700">
                {isEnglish
                  ? "Create Plan in Progress. You can Add and Remove employees."
                  : "Personaleinsatzplanung gestartet. Sie können Mitarbeiter hinzufügen, entfernen und Mitarbeiter zum Teamleiter ernennen."}
              </p>
            </div>
          ) : null}
          {isCancelPlanInProgress === true ? (
            <div className="flex justify-center mt-5">
              <p className="text-sm text-gray-700 items-center leading-6">
                {isEnglish
                  ? "Do you really want to discard this plan."
                  : "Arbeitszeitplanung wirklich beenden?"}
              </p>
              <div className="ml-5 items-center">
                <button
                  onClick={onDiscardYes}
                  type="button"
                  className="text-sm font-semibold leading-6 text-yellow-700  ring-yellow-600/20 bg-yellow-50 rounded-md ring-1 ring-inset"
                >
                  {isEnglish ? "Yes" : "Ja"}
                </button>

                <button
                  onClick={onDiscardNo}
                  type="button"
                  className="text-sm ml-4 font-semibold leading-6 text-yellow-700  ring-yellow-600/20 bg-yellow-50 rounded-md ring-1 ring-inset"
                >
                  {isEnglish ? "No" : "Nein"}
                </button>
              </div>
            </div>
          ) : null}
          <div id="divToPrint">
            {isGeneratingPDF ? (
              <div className="mt-5 px-2">
                <label className="block text-sm font-medium leading-6 text-gray-900">
                  Schedule
                </label>
                <label className="block text-sm font-medium leading-6 text-gray-900">
                  {"Date: " + currentDate}
                </label>
                <label className="block text-sm font-medium leading-6 text-gray-900">
                  {"Branch: " + selectedBranch.name}
                </label>
                <label className="block text-sm font-medium leading-6 text-gray-900">
                  {"Shift: " + selectedShift.title}
                </label>
              </div>
            ) : null}
            <SPShiftPlanPanel
              array_shiftEmployees={
                objectShiftPlan !== null ? objectShiftPlan.array_employees : []
              }
              removeEmployee={onRemove}
              isDisabled={isDisabled}
              makeTempTeamlead={onMakeTeamLead}
              isActivityIndicator={isActivityIndicatorForPlan}
              tl_id={objectShiftPlan?.team_lead_id}
              isGeneratingPDF={isGeneratingPDF}
            />
          </div>
        </div>

        <div className="sm:flex-auto mt-4 sm:ml-5 sm:w-1/5 sm:max-w-[400px]">
          <SPEmployeePanel
            array_users={filterUPUsers(empPanelUserArray)}
            onChangeBranch={onEmpPanelChangeBranch}
            onAddUser={onEmpPanelAddUser}
            isActivityIndicator={isSPEmpPanelActivity}
            isDisabled={isDisabled}
            array_branches={props.array_branches}
            selectedBranch={empPanelUserBranch}
          />
        </div>
      </div>
    </div>
  );
}
